import invokeApi from './../util/apiclient'
export const GET_INTENT_STAGE = 'GET_INTENT_STAGE'
export const GET_INTENT_INVITE = 'GET_INTENT_INVITE'
export const CANCEL_INTENT = 'CANCEL_INTENT'
export const DO_VOUCHER_STAGE = 'DO_VOUCHER_STAGE'
export const DO_VOUCHER_INVITE = 'DO_VOUCHER_INVITE'

export function getIntentForStage (teamName, stage) {
  const data = {
    teamName,
    stage,
    action: 'claimStage'
  }
    return (dispatch) => {
        return invokeApi('POST', '/payment/intent', null, data)
            .then((response) => {
                dispatch({ type: GET_INTENT_STAGE + '/SUCCESS', result: response.data, stage })
            }).catch((reason) => {
                dispatch({ type: GET_INTENT_STAGE + '/FAILED', stage })
            })
    }
}

export function getIntentForInvite (inviteId) {
  const data = {
    inviteId,
    action: 'acceptInvite'
  }
  return (dispatch) => {
      return invokeApi('POST', '/payment/intent', null, data)
          .then((response) => {
              dispatch({ type: GET_INTENT_INVITE + '/SUCCESS', result: response.data, inviteId })
          }).catch((reason) => {
              dispatch({ type: GET_INTENT_INVITE + '/FAILED', inviteId })
          })
  }
}

export function cancelIntent (intentId) {
  return (dispatch) => {
      return invokeApi('POST', '/payment/cancel-intent', null, { intent_id: intentId })
          .then((response) => {
              dispatch({ type: CANCEL_INTENT + '/SUCCESS' })
          }).catch((reason) => {
              dispatch({ type: CANCEL_INTENT + '/FAILED' })
          })
  }
}

export function claimStageWithVoucher (teamName, stage, email, voucher) {
  const data = {
    teamName, 
    stage, 
    email, 
    voucher,
    action: 'claimStage'
  }
  return (dispatch) => {
      return invokeApi('POST', '/payment/voucher', null, data)
          .then((response) => {
              dispatch({ type: DO_VOUCHER_STAGE + '/SUCCESS', voucher, stage })
          }).catch((reason) => {
              dispatch({ type: DO_VOUCHER_STAGE + '/FAILED', voucher, stage })
          })
  }
}

export function claimInviteWithVoucher (inviteId, email, voucher) {
  const data = {
    inviteId, 
    email, 
    voucher,
    action: 'acceptInvite'
  }
  return (dispatch) => {
      return invokeApi('POST', '/payment/voucher', null, data)
          .then((response) => {
              dispatch({ type: DO_VOUCHER_INVITE + '/SUCCESS', voucher, inviteId })
          }).catch((reason) => {
              dispatch({ type: DO_VOUCHER_INVITE + '/FAILED', voucher, inviteId })
          })
  }
}